import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Dialog } from "@material-ui/core";

export default function SimplePopover(props) {
  const {
    children,
    handlePopOverClose = () => {},
    currentTarget,
    useFullWidth = true,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(currentTarget);
  useEffect(() => {
    setAnchorEl(props.currentTarget);
  }, [props.currentTarget]);

  const handleClose = () => {
    setAnchorEl(null);
    handlePopOverClose(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <motion.div drag="true">
      <div>
        <Dialog
          id={id}
          fullWidth={useFullWidth}
          maxWidth={"md"}
          className="dialog-cont"
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          {children}
        </Dialog>
      </div>
    </motion.div>
  );
}
